/** Multicart Type indicates if the cart is created by a practitioner or CS agent.
 *  Possible values are:
 *  - customer
 *  - admin
 * */

enum MultiCartType {
  CUSTOMER = "customer",
  ADMIN = "admin",
}

export { MultiCartType };
